<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="javascript:;" @click="$router.back()" class="aHref">预约管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formUserInfo">
        <el-form ref="invoice" class="info" v-model="medicalAppoint" label-width="120px" label-suffix="：">
          <p class="tit medicalAppoint">预约信息</p>
          <div class="flex">
            <el-form-item label="预约编号">
              {{ medicalAppoint.appointNo }}
            </el-form-item>
            <el-form-item label="预约时间">
              {{ medicalAppoint.appointDateShow }}
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="状态">
              {{
                (medicalAppoint.appointState === 0 && medicalAppoint.payState === 0) ? '待付款'
                    : medicalAppoint.appointState === 1 ? '待通话'
                    : medicalAppoint.appointState === 2 ? '已取消'
                        : medicalAppoint.appointState === 3 ? '待分析'
                            : medicalAppoint.appointState === 4 ? '已结束'
                            : medicalAppoint.appointState === 5 ? '已取消'
                                : '有问题'
              }}
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="支付金额">
              {{ medicalAppoint.payAmount }}
            </el-form-item>
            <el-form-item label="是否点赞">
              {{ medicalAppoint.isStar > 0 ? '是' : '否' }}
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="咨询方式">
              {{ medicalAppoint.consultMode === 1 ? '语音' : '视频' }}
            </el-form-item>
            <el-form-item label="真实姓名">
              {{ medicalAppoint.realName }}
            </el-form-item>
          </div>
          <!--    <div class="flex">
            <el-form-item label="手机号码">
              {{ medicalAppoint.mobile }}
            </el-form-item>
            <el-form-item label="邮箱">
              {{ medicalAppoint.email }}
            </el-form-item>
          </div>-->
          <div class="flex">
            <el-form-item label="年龄">
              {{ medicalAppoint.age }}岁
            </el-form-item>
            <el-form-item label="性别">
              {{ medicalAppoint.gender === 1 ? '男' : medicalAppoint.gender === 2 ? '' : '-' }}
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="所在城市">
              {{ medicalAppoint.abodeCity }}
            </el-form-item>
            <el-form-item label="职业">
              {{ medicalAppoint.occupation }}
            </el-form-item>
          </div>
          <el-form-item label="备注">
            {{ medicalAppoint.remark }}
          </el-form-item>
          <el-form-item label="问题描述">
            {{ medicalAppoint.problemDesc }}
          </el-form-item>
          <el-form-item label="期望效果">
            {{ medicalAppoint.expectEffect }}
          </el-form-item>
          <!--<el-form-item label="通话时长（秒）">-->
          <!--    {{medicalAppoint.duration}}-->
          <!--</el-form-item>-->
        </el-form>
        <el-form ref="invoice" class="info" v-model="medicalRecord" v-if="medicalRecord" label-width="100px"
                 label-suffix="：">
          <p class="tit">咨询信息</p>
          <el-form-item label="咨询编号">
            {{ medicalRecord.medicalNo }}
          </el-form-item>
          <el-form-item label="咨询时间">
            {{ medicalRecord.medicalDate }}
          </el-form-item>
          <el-form-item label="咨询原因">
            {{ medicalRecord.medicalReason }}
          </el-form-item>
          <el-form-item label="咨询建议">
            {{ medicalRecord.result }}
          </el-form-item>
          <el-form-item label="建议">
            {{ medicalRecord.adviseWritten }}
          </el-form-item>
          <el-form-item label="用药建议">
            {{ medicalRecord.adviseDrug }}
          </el-form-item>
          <el-form-item label="建议医院">
            {{ medicalRecord.adviseHospital }}
          </el-form-item>
          <el-form-item label="建议医生">
            {{ medicalRecord.adviseDoctor }}
          </el-form-item>
          <el-form-item label="依从性">
            {{
              medicalRecord.patientCompliance === 1 ? '完全依从'
                  : medicalRecord.patientCompliance === 2 ? '部分依从'
                  : '完全不依从'
            }}
          </el-form-item>
        </el-form>
        <el-form class="info" v-model="medicalRecord" label-width="100px" label-suffix="：">
          <p class="tit">双方账户信息</p>
          <div class="flex">
            <el-form-item label="医生">
              <el-button @click="toDoctor()">{{ doctorName }}</el-button>
            </el-form-item>
            <el-form-item label="用户">
              <el-button @click="toUser()">{{ userName }}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "appointDetail",
  /*props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    appointDelId: {
      type: Number
    },
  },*/
  data() {
    return {
      // dialogRole: this.dialogFormVisible,
      appointId: this.$route.params.id,
      medicalAppoint: {},
      medicalRecord: {},
      doctorName: '',
      userName: '',
    }
  },
  mounted() {
    let that = this;
    this.$ajax
        .get(commonjs.api.appoint.admin.detail.replace("{id}", this.appointId))
        .then(function (res) {
          if (res.data.status === 'success') {
            that.medicalAppoint = res.data.data.medicalAppoint;

            that.medicalAppoint.appointDateShow = commonjs.utils.buildShowDate(that.medicalAppoint.appointStartLongtime, that.medicalAppoint.appointEndLongtime);

            that.medicalRecord = res.data.data.medicalRecord;
            that.doctorName = res.data.data.doctorName;
            that.userName = res.data.data.userName;
          } else {
            // that.$router.back();
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error("信息加载失败");
        })
  },
  methods: {
    toDoctor() {
      this.$router.push({path: '../../doctor/detail/' + this.medicalAppoint.doctorId})
    },
    toUser() {
      this.$router.push({path: '../../user/detail/' + this.medicalAppoint.userId})
    },
    dialogClose() {
      this.$emit("closePark");
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/personalCenter.scss";

.centerPage {
  display: block;
  width: auto;
  padding: 0;

  .el-form-item {
    width: 50%;
  }

  ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #303139;
  }

  .formUserInfo ::v-deep .el-form-item__content .el-input__inner[readonly="readonly"] {
    border: none;
    color: #303139;
  }

  .formUserInfo ::v-deep .el-form-item__content .el-input__inner {
    color: #666666;
  }

}

label.el-form-item__label:before {
  content: '';
}
</style>
